import classNames from 'classnames';
import React from 'react';
import { ButtonColor, ConfirmationModal } from '..';
import { ConfirmationModalProps } from '../../../modules/partner-portal/dashboards/integration/modals/types';

import './delete-modal.scss';

type DeleteModalProps = ConfirmationModalProps & {
    headline: string;
    text?: string;
    cancelColor?: ButtonColor;
    cancelButtonText?: string;
    cancelIsDisabled?: boolean;
    confirmButtonText?: string;
    icon?: string;
};

export const DeleteModal: React.FC<DeleteModalProps> = ({
    isOpen,
    isLoading = false,
    cancelColor,
    cancelButtonText = 'Cancel',
    cancelIsDisabled,
    confirmButtonText = 'Delete',
    cancelOnClick,
    confirmOnClick,
    headline,
    text,
    icon = 'fak fa-prizeout-alert-circle',
}): React.ReactElement => {
    const iconClasses = classNames(icon, 'delete-modal__icon');

    return (
        <ConfirmationModal
            isConfirmationModalOpen={isOpen}
            cancelOnClick={cancelOnClick}
            cancelColor={cancelColor}
            cancelButtonText={cancelButtonText}
            cancelIsDisabled={cancelIsDisabled}
            confirmOnClick={confirmOnClick}
            confirmIsLoading={isLoading}
            headline={headline}
            subheadline={text}
            confirmColor={ButtonColor.DESTRUCTIVE}
            confirmButtonText={confirmButtonText}
            iconClasses={iconClasses}
        />
    );
};
